export const CODING_QA_MOMENT_LONG_DATE_FORMAT = "MM/DD/YYYY hh:mm A";
export const MOMENT_LONG_DATE_FORMAT = "MM/DD/YYYY hh:mm A";
export const MOMENT_SHORT_DATE_FORMAT = "MM/dd/yyyy";

export const DATE_FNS_LONG_DATE_FORMAT = "MM/dd/yyyy hh:mm a";
export const DATE_FNS_SHORT_DATE_FORMAT = "MM/dd/yyyy";
export const DATE_FNS_ISO_DATE_FORMAT = "yyyy-MM-dd";

export const DEFAULT_GENERIC_ERROR = "An error has occurred";

export const KEYCODE = {
    BACKSPACE: 8,
    TAB: 9,
    RETURN: 13,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
};

export const EMPTY_PAGINATION = {
    count: 0,
    currentPage: 1,
    items: [],
    pageSize: 20,
    totalPageCount: 0,
    totalRecordCount: 0,
};

export const BASIC_TASK_STATUSES = [
    {
        text: "All",
        value: 0,
    },
    {
        text: "In Progress",
        value: 1,
    },
    {
        text: "Completed",
        value: 2,
    },
];

export const CONTEXT_STATUS = {
    InProgress: {
        text: "In Progress",
    },
    Completed: {
        text: "Completed",
    },
    Rejected: {
        text: "Rejected",
    },
};

export const TASK_PERMISSIONS = {
    selectPhotographyPackageType: "select:photographypackagetype",
    accessPackageHierarchy: "access:packagehierarchylinkingtool",
    viewBrandVerifiedQa: "view:brandverifiedqatasklist",
};
